module.exports = __webpack_public_path__ + "static/media/smp_bg.1585796a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/smp_bg.png
// module id = 2247
// module chunks = 0